import { Box } from '@material-ui/core'
import React, { useContext } from 'react'
import AppContext from '../../../app/context'
import { MOBILE_WIDTH_HIGH } from '../../../constants/constants'
import { useWindowSize } from '../../../hooks/useWindowSize'
import LeftDecorationIcon from '../../icons/left_decoration'
import RightDecorationIcon from '../../icons/right_decoration'
import Footer from '../footer/Footer'
import buildStyles from './styles'

interface RightSideProps {
  withSideImage?: boolean
  centeredRightSide?: boolean
  withoutDecorations?: boolean
  children: React.ReactNode
}

const RightSide = ({
  withSideImage,
  centeredRightSide,
  withoutDecorations,
  children,
}: RightSideProps) => {
  const { state } = useContext(AppContext)

  const screen = useWindowSize()
  const isMobile: boolean = (screen.width as number) < MOBILE_WIDTH_HIGH

  if (!state.locationDesignConfig) return null
  const styles = buildStyles({
    withSideImage: !!withSideImage,
    centeredRightSide: !!centeredRightSide,
    baseColors: state.locationDesignConfig.baseColors,
  })

  return (
    <Box
      position="relative"
      width="100%"
      overflow="auto"
      className={styles.wrapper}
    >
      {!withoutDecorations && !isMobile && (
        <>
          <LeftDecorationIcon className={styles.leftDecoration} />
          <RightDecorationIcon className={styles.rightDecoration} />
        </>
      )}
      <Box className={styles.wrapper}>
        <Box className={styles.container}>{children}</Box>
        <Footer />
      </Box>
    </Box>
  )
}

export default RightSide
